// extracted by mini-css-extract-plugin
export var arrowSlider = "slick-module--arrowSlider--6D0US";
export var arrowNext = "slick-module--arrowNext--ZU5en";
export var arrowPrev = "slick-module--arrowPrev--jGPso";